// extracted by mini-css-extract-plugin
export default {"section":"HomeUs_section__HBfXh","wrapper":"HomeUs_wrapper__I7Nno","images":"HomeUs_images__BXi9k","text":"HomeUs_text__ZMAmR"};